// extracted by mini-css-extract-plugin
export default {"header":"JsonData_header__wiSNP","containerData":"JsonData_containerData__B0tjQ"};